import { useModalContext } from 'utils/contexts/modal/context';
import { RestoreTemplateModal } from './RestoreTemplateModal';
import type { TemplateDiffModalState } from '../../types';

export const TemplateDiffModals = () => {
  const { modalState, hideModal } = useModalContext<TemplateDiffModalState>();
  if (modalState === null) return null;

  const { action } = modalState;
  switch (action) {
    case 'restoreTemplateModal':
      return (
        <RestoreTemplateModal
          newContent={modalState.newContent}
          onClose={hideModal}
          templateId={modalState.templateId}
        />
      );
    default:
      return null;
  }
};
